<h1 class="no-margin no-padding" mat-dialog-title>{{title}}</h1>
<div mat-dialog-content [innerHtml]="message">
  <!-- {{message}} -->
</div>
<div mat-dialog-actions align="center">
  <button *ngFor="let o of options" mat-flat-button color="accent" (click)="dismiss(o)">{{o}}</button>
</div>
